import React from 'react'
import { useMutation } from '@apollo/client'
import VisibilitySensor from 'react-visibility-sensor'
import markRead from '../mutations/mark-read'
import { formatDistance } from 'date-fns'

const Notification = ({ active, data, parentRef }) => {
  const [markReadMutation] = useMutation(markRead)

  const handleMarkRead = (isVisible) => {
    if (!isVisible) return // Only mark if visible

    const { id, read } = data

    if (read) return // Don't mark if already read

    markReadMutation({ variables: { id } })
  }

  const now = new Date()
  const nowUTC = new Date(now.valueOf() + now.getTimezoneOffset() * 60000)

  if (!data) return null

  return (
    <VisibilitySensor
      active={active}
      partialVisibility
      onChange={handleMarkRead}
      intervalCheck={false}
      scrollCheck
      scrollDelay={100}
    >
      <div className="notification">
        <div className="message">
          <p dangerouslySetInnerHTML={{ __html: data.message }} />
        </div>
        <div className="created-at">
          <p>{formatDistance(new Date(data.updatedAt), nowUTC)} ago</p>
        </div>
      </div>
    </VisibilitySensor>
  )
}

export default Notification
